import React, { Component } from 'react';
import injectSheet from 'react-jss';

import styles from './withHover.styles';

function withHover(WrappedComponent) {
  class WithHover extends Component {
    constructor(props) {
      super(props);

      this.handleOnMouseEnter = this.handleOnMouseEnter.bind(this);
      this.handleOnMouseLeave = this.handleOnMouseLeave.bind(this);

      this.state = { isHovered: false };
    }

    handleOnMouseEnter() {
      this.setState({ isHovered: true });
    }

    handleOnMouseLeave() {
      this.setState({ isHovered: false });
    }

    render() {
      const { classes } = this.props;

      return (
        <div
          className={classes.componentWrapper}
          onMouseEnter={this.handleOnMouseEnter}
          onMouseLeave={this.handleOnMouseLeave}
        >
          <WrappedComponent isHovered={this.state.isHovered} {...this.props} />
        </div>
      );
    }
  }

  return injectSheet(styles)(WithHover);
}

export default withHover;
